import { render } from "./TableBody.vue?vue&type=template&id=559601d2&scoped=true"
import script from "./TableBody.vue?vue&type=script&lang=js"
export * from "./TableBody.vue?vue&type=script&lang=js"

import "./TableBody.vue?vue&type=style&index=0&id=559601d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-559601d2"]])

export default __exports__